import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "default__container" }
const _hoisted_5 = { class: "station-handler-ticket" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonLayout = _resolveComponent("CommonLayout")!
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_Default = _resolveComponent("Default", true)!
  const _component_ThemeProvider = _resolveComponent("ThemeProvider")!

  return (_openBlock(), _createBlock(_component_ThemeProvider, { theme: {} }, {
    default: _withCtx(() => [
      _createVNode(_component_CommonLayout),
      _createVNode(_component_Default, null, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
            : _createCommentVNode("", true),
          _createVNode(_component_Navbar, {
            "airline-logo": _ctx.airlineLogo,
            "selected-lang": _ctx.selectedLang,
            langs: _ctx.langs
          }, null, 8, ["airline-logo", "selected-lang", "langs"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.groundHandlerMessage?.homepage_new.SFS_LANG_ROW_31), 1)
            ]),
            _createVNode(_component_router_view)
          ]),
          _createVNode(_component_Footer)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}